import React from 'react'
import ExchangeRateCountryCurrency from '../ExchangeRateCountryCurrency/ExchangeRateCountryCurrency';


const ExchangeRateIndex = () => {
 
  return (
    <div>
      <ExchangeRateCountryCurrency />
    </div>
  )
}

export default ExchangeRateIndex
